import axios from 'axios'
const queryString = require('query-string')
export default {
  autenticar ({state, commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      commit('loadingAutenticacao', true)
      window.http.post('Autentica/Login', queryString.stringify(payload))
      .then((response) => {
        commit('loadingAutenticacao', false)
        let data = response.data.resultado
        if (data.code === 200) {
          // store TOKEN
          let auth = {
            nome: data.nome,
            nivel: data.nivel,
            token: data.token,
            status: data.status
          }
          commit('singIn', auth)
          if (!payload.mantemConectado) {
            auth.time = 1000 * 60 * 10
            dispatch('singOut', auth.time)
            commit('createSession', auth)
          } else {
            auth.time = false
            commit('createSession', auth)
          }
          resolve()
        } else {
          if (data.code === 302) {
            commit('toastr', {
              color: 'error',
              texto: 'Usuário inválido'
            })
          } else if (data.code === 303) {
            commit('toastr', {
              color: 'error',
              texto: 'Senha inválida'
            })
          } else if (data.code === 304) {
            commit('toastr', {
              color: 'error',
              texto: 'E-mail não confirmado'
            })
          } else if (data.code === 501) {
            commit('toastr', {
              color: 'error',
              texto: 'Erro interno'
            })
          }
          reject(data.code)
        }
      })
      .catch((error) => {
        commit('loadingAutenticacao', false)
        commit('toastr', {
          color: 'error',
          texto: 'Erro de conexão'
        })
        reject(error)
      })
    })
  },
  logOut ({commit, rootGetters}) {
    commit('resetAgendamento')
    commit('resetEmpresa')
    commit('resetItem')
    commit('resetCategorie')
    commit('resetPedido')
    commit('singOut')
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: process.url + 'Autentica/Logout',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        resolve()
      })
    })
  },
  singOut ({ commit }, time) {
    setTimeout(() => {
      commit('singOut')
      window.location = '/Expirado'
    }, time)
  }
}



// WEBPACK FOOTER //
// ./src/store/autenticacao/actions.js